import { signoutUser } from '../../self-onboarding-mf/src/actions/signOutUser';
import getHistory from './getHistory';

const logoutUserFromOyo360 = ({ store }) => {
    const history = getHistory();

    store.dispatch(signoutUser({ history }));
};

export default logoutUserFromOyo360;
